/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './eye.reducer';

export const EyeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const eyeEntity = useAppSelector(state => state.eye.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="eyeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.eye.detail.title">Eye</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.eye.id">Id</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.id}</dd>
          <dt>
            <span id="displayOrder">
              <Translate contentKey="tinyMedicRestApp.eye.displayOrder">Display Order</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.displayOrder}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.eye.name">Name</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.name}</dd>
          <dt>
            <span id="locale">
              <Translate contentKey="tinyMedicRestApp.eye.locale">Locale</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.locale}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.eye.active">Active</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.eye.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.eye.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.eye.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.eye.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{eyeEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/eye" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/eye/${eyeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EyeDetail;
